import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  connect() {
    // this.element is the form element itself
    this.boundHandleKeydown = this._handleKeydown.bind(this)
    this.element.addEventListener("keydown", this.boundHandleKeydown)
    // console.log("Form submit shortcut controller connected to:", this.element)
  }

  disconnect() {
    this.element.removeEventListener("keydown", this.boundHandleKeydown)
    // console.log("Form submit shortcut controller disconnected from:", this.element)
  }

  _handleKeydown(event) {
    // Check for Enter key
    if (event.key === "Enter") {
      // Check for Command key (Mac) or Control key (Windows/Linux)
      if (event.metaKey || event.ctrlKey) {
        // Prevent default behavior (e.g., adding a newline in a textarea)
        event.preventDefault()

        // console.log("Shortcut pressed! Submitting form:", this.element)

        // Option 1: Directly submit the form.
        // This bypasses some client-side validation and doesn't trigger submit event listeners
        // attached to the form via addEventListener('submit', ...), but it will trigger the
        // form's own 'submit' event which leads to the browser submitting it.
        // this.element.submit()

        // Option 2: More robustly, find and "click" a submit button if one exists.
        // This usually triggers client-side validation and all submit event listeners.
        // If no explicit submit button, fall back to requestSubmit().
        const submitButton = this.element.querySelector('button[type="submit"], input[type="submit"]')
        if (submitButton) {
          // console.log("Clicking submit button:", submitButton)
          submitButton.click()
        } else {
          // console.log("No submit button found, using requestSubmit()")
          // requestSubmit() is a more modern way that also triggers validation
          // and the form's 'submit' event.
          if (typeof this.element.requestSubmit === "function") {
            this.element.requestSubmit()
          } else {
            // Fallback for older browsers or if requestSubmit is not available
            this.element.submit()
          }
        }
      }
    }
  }
}
